import { Lookup, Lookups } from "./entities";
import LookupUtil from "@my-dld/utils/LookupUtil";
import { getLookup } from "./api";

export function getGreenListAres(): Promise<Lookup[]> {
	const cache = LookupUtil.getFromCache( "GL-Areas" ) as Lookup[];
	if ( cache && cache.length > 0 ) return Promise.resolve( cache );
	return getLookup( Lookups.AREAS ).then( x => {
		LookupUtil.putToCache( "GL-Areas", x );
		return Promise.resolve( x );
	} );
}
